import request from '@/utils/request'
const apiPath = '/cust/userWallet'
import { downloadBlob } from '@/utils/download'
const userWalletApi = {
  importExceltemplate(data) {
    return request.post(apiPath + '/importExcel', data)
  },
  exportExcel(query) {
    return request.get(`${apiPath}/importExceltemplate`, { responseType: 'blob', params: query })
      .then(res => downloadBlob(res, '钱包模板.xlsx'))
  },
}
export default userWalletApi
